import isLocalePresentInUrl from '~/utils/routing/isLocalePresentInUrl'
import type { Language } from '~/types/storeTypes'
import fetchLanguagesConfig from '~/utils/config/languages/fetchLanguagesConfig'
import getDefaultLocale from '~/utils/locale/getDefaultLocale'
import { H3Event } from 'h3'

export const useDetectLocale = () => {
  const route = useRoute()

  const defaultLocale: string = getDefaultLocale().iso

  const getLocale = async (): Promise<string> => {
    const languagesList = await getLanguagesList()

    const path: string = route.path
    const isLocalePresent: boolean = isLocalePresentInUrl(path)
    const localeInUrl: string | null = isLocalePresent ? path.split('/')[1] : null

    if (localeInUrl) {
      const isValidLocale: boolean = languagesList.some((lang): boolean => {
        return lang.iso_code.toLowerCase() === localeInUrl.toLowerCase()
      })

      if (isValidLocale) {
        return localeInUrl
      }
    }

    return defaultLocale
  }

  const getLanguagesList = async (): Promise<Pick<Language, 'id' | 'iso_code'>[]> => {
    const languagesList = useState<Pick<Language, 'id' | 'iso_code'>[]>('locale.languagesList')

    if (!languagesList.value) {
      languagesList.value = await fetchLanguagesConfig()
    }

    return languagesList.value
  }

  return {
    getLocale,
  }
}
